import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';
import { TRACKING_EVENT_NAMES, ACTION_SUBJECT_IDS } from '../../utils/constants';
import { containerStyle, buttonStyle } from './cart-button.styles';
import { CartIcon } from './cart-icon';
const CartButton = ({ analyticsAttributes, numberOfProductTrials, onClick }) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    useEffect(() => {
        createAnalyticsEvent({
            eventName: TRACKING_EVENT_NAMES.wacCartRendered,
            action: 'rendered',
            actionSubject: 'wacCart',
            actionSubjectId: ACTION_SUBJECT_IDS.wacCartRendered,
            attributes: analyticsAttributes
        }).fire();
    }, []);
    return (_jsx("div", { css: containerStyle, children: _jsx("button", { "data-testid": "cart-button", css: buttonStyle, onClick: onClick, title: `View ${numberOfProductTrials} product ${numberOfProductTrials > 1 ? 'trials' : 'trial'} ending soon`, children: _jsx(CartIcon, { numberOfProductTrials: numberOfProductTrials > 5 ? '5 +' : `${numberOfProductTrials}` }) }) }));
};
export { CartButton };
//# sourceMappingURL=cart-button.js.map